"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
// (C) 2007-2020 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var react_intl_1 = require("react-intl");
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var format_1 = require("./utils/format");
var pop_1 = require("./utils/pop");
var sdk_ui_vis_commons_1 = require("@gooddata/sdk-ui-vis-commons");
var LOADING_PLACEHOLDER = "…";
var NO_DATA_PLACEHOLDER = format_1.HYPHEN;
var KpiPop = /** @class */ (function (_super) {
    tslib_1.__extends(KpiPop, _super);
    function KpiPop() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.kpiSectionItemNode = react_1.default.createRef();
        _this.renderPercentage = function () {
            var popInfo = _this.props.disabled || !!_this.props.error
                ? pop_1.getErrorPopInfo()
                : pop_1.getPopInfo(_this.props.previousPeriodValue, _this.props.currentPeriodValue, _this.props.meaning);
            var tooltip = _this.props.isLoading ? "" : popInfo.percentage;
            return (react_1.default.createElement("dl", { className: "gd-flex-item kpi-pop-section-item kpi-pop-change headline-compare-section-item headline-tertiary-item" },
                react_1.default.createElement("div", { className: "headline-value-wrapper s-headline-value-wrapper" },
                    react_1.default.createElement(sdk_ui_kit_1.ResponsiveText, { title: tooltip, tagClassName: "is-kpi-" + popInfo.meaning, tagName: "dt" }, _this.renderPercentageValue(popInfo))),
                react_1.default.createElement("dd", null,
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "kpiPop.change" }))));
        };
        _this.renderPreviousPeriod = function () {
            return (react_1.default.createElement("dl", { className: "gd-flex-item kpi-pop-section-item kpi-pop-period headline-compare-section-item headline-secondary-item", title: _this.renderFormattedValue() },
                react_1.default.createElement(sdk_ui_kit_1.ResponsiveText, { tagName: "dt" }, _this.renderPreviousPeriodValue()),
                _this.renderPreviousPeriodName()));
        };
        return _this;
    }
    KpiPop.prototype.render = function () {
        var _a = this.props, enableCompactSize = _a.enableCompactSize, clientHeight = _a.clientHeight, clientWidth = _a.clientWidth;
        var pagination = sdk_ui_vis_commons_1.shouldRenderPagination(enableCompactSize, clientWidth, clientHeight);
        if (pagination) {
            return (react_1.default.createElement("div", { className: "gd-flex-container headline-compare-section headline-paginated-compare-section" },
                react_1.default.createElement(sdk_ui_vis_commons_1.HeadlinePagination, { renderSecondaryItem: this.renderPreviousPeriod, renderTertiaryItem: this.renderPercentage })));
        }
        return (react_1.default.createElement("div", { className: this.getKpiSectionClassName() },
            this.renderPercentage(),
            this.renderPreviousPeriod()));
    };
    KpiPop.prototype.renderPercentageValue = function (popInfo) {
        return this.props.isLoading ? (false) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("span", { className: classnames_1.default("gd-icon-trend-" + popInfo.trend, "gd-kpi-trend-icon") }),
            popInfo.percentage));
    };
    KpiPop.prototype.renderPreviousPeriodName = function () {
        return this.props.previousPeriodName ? (react_1.default.createElement("dd", { className: "headline-title-wrapper", ref: this.kpiSectionItemNode, title: this.props.previousPeriodName }, this.props.previousPeriodName)) : (false);
    };
    KpiPop.prototype.renderPreviousPeriodValue = function () {
        if (this.props.isLoading) {
            return LOADING_PLACEHOLDER;
        }
        return this.props.error ? this.formatMessage("error") : this.renderFormattedValue();
    };
    KpiPop.prototype.renderFormattedValue = function () {
        var value = this.props.previousPeriodValue;
        if (this.props.disabled || format_1.isValueUnhandledNull(value, this.props.format)) {
            return NO_DATA_PLACEHOLDER;
        }
        return format_1.formatMetric(value, this.props.format, this.props.separators);
    };
    KpiPop.prototype.getKpiSectionClassName = function () {
        var clientWidth = this.props.clientWidth;
        var kpiSectionItemNode = this.kpiSectionItemNode.current;
        var className = "gd-flex-container headline-compare-section";
        var responsiveClassName = sdk_ui_vis_commons_1.getHeadlineResponsiveClassName(clientWidth);
        if (kpiSectionItemNode && responsiveClassName) {
            return className + " " + responsiveClassName;
        }
        return className;
    };
    KpiPop.prototype.formatMessage = function (id) {
        return this.props.intl.formatMessage({ id: id });
    };
    KpiPop.defaultProps = {
        error: null,
        disabled: false,
        isLoading: false,
        previousPeriodName: "",
        clientWidth: 0,
        clientHeight: 0,
    };
    return KpiPop;
}(react_1.PureComponent));
exports.default = react_intl_1.injectIntl(KpiPop);
//# sourceMappingURL=KpiPop.js.map